module.exports = __webpack_public_path__ + "static/media/postgresql.72a6ae18.svg";